/**
 * Route stop detection shared by the map (stop markers on the drawn track) and the info panel
 * (the "recent events" list). A stop = a run of near-stationary points lasting at least MIN_STOP.
 * Field names match the v2 route payload (route_data): device_timestamp [unix s], basic_speed [km/h].
 */
export interface RouteStop {
  startTs: number
  endTs: number
  lat: number
  lng: number
}

const IDLE_KMH = 3
const MIN_STOP_SECONDS = 300

function pointTs(p: any): number {
  return Number(p?.device_timestamp ?? p?.dt ?? p?.timestamp)
}

function pointSpeed(p: any): number {
  const n = Number(p?.basic_speed ?? p?.speed)
  return Number.isFinite(n) ? n : 0
}

export function detectStops(
  points: Array<any>,
  idleKmh: number = IDLE_KMH,
  minStopSeconds: number = MIN_STOP_SECONDS
): RouteStop[] {
  if (!Array.isArray(points) || points.length < 2) return []

  const stops: RouteStop[] = []
  let start: any = null
  let startTs = 0
  let prevTs = 0

  for (const p of points) {
    const t = pointTs(p)
    if (!Number.isFinite(t)) continue
    if (pointSpeed(p) <= idleKmh) {
      if (start === null) {
        start = p
        startTs = t
      }
      prevTs = t
    } else if (start !== null) {
      if (prevTs - startTs >= minStopSeconds) {
        stops.push({ startTs, endTs: prevTs, lat: Number(start.lat), lng: Number(start.lng) })
      }
      start = null
    }
  }
  if (start !== null && prevTs - startTs >= minStopSeconds) {
    stops.push({ startTs, endTs: prevTs, lat: Number(start.lat), lng: Number(start.lng) })
  }
  return stops
}
